// remove-query-string.js
export function removeQueryString() {
  return {
    name: 'remove-query-string', // 插件名称
    resolveId(importee) {
      // 如果导入路径包含 '?'
      if (importee.includes('?')) {
        // 分割 '?' 前后的内容，并返回 '?' 前的路径作为新的导入路径
        const [resolvedImportee] = importee.split('?')
        return resolvedImportee
      }
      return null
    }
  }
}
